/* BF-only adapter. Calendar projection from Core delivery-promise-calendar.ts;
 * live warehouse profile read 26 Oct 2026: London/noon, Mon–Fri, preparation=0.
 * Core overrides UK delivery to Mon–Sat. Re-review before 1 Jan 2027.
 * Dates are estimates; Shopify remains the source for checkout service/rates. */
(function (root, factory) {
  var calendar = factory();
  if (typeof module === 'object' && module.exports) module.exports = calendar;
  else if (root.dsrcvDeliveryPromiseConfig && root.dsrcvDeliveryPromiseConfig.blackFridayDispatch === true &&
    ['187070447994', '208998072645'].indexOf(String(root.dsrcvDeliveryPromiseConfig.themeId)) !== -1) root.dsrcvBlackFridayDates = calendar;
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var end = '2027-01-01';
  var rulesVersion = 'c2b79d3ac79f8532';
  var dispatchClosures = ['2026-08-31', '2026-12-25', '2026-12-28', '2027-01-01'];
  var deliveryClosures = dispatchClosures.concat(['2026-12-26']);
  function key(date) { return date.toISOString().slice(0, 10); }
  function parse(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    var d = new Date(value + 'T12:00:00Z');
    return Number.isFinite(d.getTime()) && key(d) === value ? d : null;
  }
  function plus(date) { return new Date(date.getTime() + 86400000); }
  function eligible(date, delivery) {
    var day = date.getUTCDay();
    return day > 0 && (delivery || day < 6) && (delivery ? deliveryClosures : dispatchClosures).indexOf(key(date)) < 0;
  }
  function add(date, count, delivery) {
    var d = new Date(date);
    for (var attempts = 0; count > 0 && attempts < 60; attempts++) {
      d = plus(d);
      if (key(d) > end) return null;
      if (eligible(d, delivery)) count--;
    }
    return count === 0 ? d : null;
  }
  function parts(now) {
    var values = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(now).forEach(function (p) { if (p.type !== 'literal') values[p.type] = p.value; });
    return { date: parse(values.year + '-' + values.month + '-' + values.day), afterCutoff: Number(values.hour) >= 12 };
  }
  function transit(label) {
    var text = String(label || '').trim();
    if (/^(?:Delivered )?Next Day(?: Once Dispatched)?$/i.test(text)) return 1;
    var match = text.match(/^(\d+)(?:\s*[-–]\s*(\d+))?\s+days?$/i);
    var days = match && Number(match[2] || match[1]);
    return Number.isInteger(days) && days > 0 && days <= 30 ? days : null;
  }
  function adjust(payload, country, now) {
    var result = payload && payload.result;
    var time = new Date(now);
    var generated = new Date(payload && payload.generatedAt);
    if (!payload || payload.rulesVersion !== rulesVersion || !result || !result.visible || !Number.isFinite(time.getTime()) || !Number.isFinite(generated.getTime()) ||
      Math.abs(time - generated) > 300000 || !Array.isArray(result.handlingDays) || !result.handlingDays.length ||
      result.handlingDays.some(function (n) { return !Number.isInteger(n) || n < 0; })) return null;
    var clock = parts(time);
    var original = parse(result.dispatchDate);
    if (!clock.date || key(clock.date) < '2026-10-26' || key(clock.date) > end || !original ||
      key(original) < key(clock.date) || key(original) > end || result.cutoffPassed !== clock.afterCutoff) return null;
    var first = clock.afterCutoff ? plus(clock.date) : clock.date;
    for (var n = 0; n < 60 && !eligible(first, false); n++) first = plus(first);
    // First eligible processing day is day one; allow up to two working days.
    var dispatch = add(first, 1, false);
    if (!dispatch) return null;
    if (original > dispatch) dispatch = original; // Never shorten a product's own handling.
    var answer = Object.assign({}, result, { dispatchDate: key(dispatch), deliveryDateMin: null, deliveryDateMax: null, message: null, bfEstimate: true, bfNormalDeliveryFloor: result.deliveryDateMax });
    if (country === 'GB') {
      var days = transit(payload.shippingQuote && payload.shippingQuote.transitWindowLabel);
      var normalMax = parse(result.deliveryDateMax);
      var delivery = days && add(dispatch, days, true);
      if (delivery && normalMax && key(normalMax) <= end) {
        if (normalMax > delivery) delivery = normalMax;
        answer.deliveryDateMin = key(delivery);
        answer.deliveryDateMax = key(delivery);
      }
    }
    return answer;
  }
  function forService(result, label) {
    if (!result || !result.bfEstimate) return result;
    var answer = Object.assign({}, result, { deliveryDateMin: null, deliveryDateMax: null });
    var days = transit(label);
    var dispatch = parse(result.dispatchDate);
    var delivery = days && dispatch && add(dispatch, days, true);
    var floor = parse(result.bfNormalDeliveryFloor);
    if (delivery && floor && key(floor) <= end) {
      if (floor > delivery) delivery = floor;
      answer.deliveryDateMin = answer.deliveryDateMax = key(delivery);
    }
    return answer;
  }
  function rangeForService(result, label) {
    var answer = forService(result, label);
    var match = String(label || '').trim().match(/^(\d+)\s*[-–]\s*(\d+)\s+days?$/i);
    if (!answer || !answer.deliveryDateMax || !match) return answer;
    var min = Number(match[1]), max = Number(match[2]);
    if (!Number.isInteger(min) || min < 1 || max < min || max > 30) return Object.assign({}, answer, {deliveryDateMin: null, deliveryDateMax: null});
    var dispatch = parse(result.dispatchDate);
    var first = dispatch && add(dispatch, min, true);
    var floor = parse(result.bfNormalDeliveryFloor);
    var last = parse(answer.deliveryDateMax);
    if (!first || !floor || !last) return Object.assign({}, answer, {deliveryDateMin: null, deliveryDateMax: null});
    if (floor > first) first = floor;
    return Object.assign({}, answer, {deliveryDateMin: key(first > last ? last : first)});
  }
  function format(value, locale) {
    var d = parse(value);
    return d ? new Intl.DateTimeFormat(locale || 'en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d) : '';
  }
  function message(result, country, mixed) {
    if (!result || !result.bfEstimate) return '';
    var delivery = country === 'GB' && result.deliveryDateMax;
    var date = format(delivery || result.dispatchDate);
    if (delivery && result.deliveryDateMin && result.deliveryDateMin !== result.deliveryDateMax) {
      return (mixed ? 'In-stock: ' : '') + 'Estimated delivery ' + format(result.deliveryDateMin) + ' to ' + date;
    }
    return (mixed ? 'In-stock: ' : '') + (delivery ? 'Estimated delivery by ' : 'Estimated despatch by ') + date;
  }
  return { adjust: adjust, forService: forService, rangeForService: rangeForService, message: message, parse: parse, reviewedThrough: end };
}));
